export default "__VITE_ASSET__Di8_8UzY__"